import React, { useEffect, useState } from "react";
import { ProductService } from "../../services/product.service";
import { Product } from "../../commonTypes";
import ProductCard from "../product/ProductCard";
import styles from "./productDetail.module.css";

interface Props {
  product: Product;
}

const ProductRecommendation = ({ product }: Props) => {
  const [recommendedProducts, setRecommendedProducts] = useState<Product[]>([]);

  useEffect(() => {
    const fetchRecommendations = async () => {
      // Find the concept tag
      const conceptTag = product.filter_tags?.find(
        (tag) => tag.indexOf("concept") > -1
      );

      if (!conceptTag) {
        setRecommendedProducts([]);
        return;
      }

      try {
        const products = await ProductService.getRecommendedProducts(
          conceptTag,
          product.id,
          4
        );
        setRecommendedProducts(products);
      } catch (error) {
        console.error("Error fetching recommendations:", error);
      }
    };

    if (product?.id) {
      fetchRecommendations();
    }
  }, [product?.id, product?.filter_tags]);

  if (recommendedProducts.length === 0) {
    return null;
  }

  return (
    <div className={styles.recommendationContainer}>
      <div className={styles.recommendation}>
        <h3>You might like</h3>

        <div className={styles.recommendationProducts}>
          {recommendedProducts.map((prod) => (
            <ProductCard key={prod.id} product={prod} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductRecommendation;
